<template>
  <div>
    <section class="row">
      <div class="col-xs-12 text-center">
        <h4>{{ product.name }}</h4>
        <code>{{ product.upc_13 }}</code>
      </div>
    </section>

    <section class="row">
      <div class="col-xs-12">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2">Name</th>
              <th class="text-center">Processed</th>
              <th class="text-center">Completed</th>
              <th class="text-center">Out of Stock</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in items"
              :grouped="true"
              :item="item"
              is="item"
              track-by="id"
            ></tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="row">
      <div class="col-xs-12 text-center">
        <button v-link="{ path: '/item-groups' }" class="btn btn-lg btn-link">
          <i class="fa fa-chevron-left"></i> Back
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import { get } from 'lodash';
import Item from '../Item';
import { Api } from 'src/utilities';
import Stash from 'src/stash';
import InteractsWithState from 'mixins/InteractsWithState';

export default {
  mixins: [InteractsWithState],
  route: {
    activate: transition =>
      Api.get(`item-groups/${transition.to.params.id}`, {
        channel: 'foreground',
      }).then(response => Stash.setItemGroup(response.data)),
  },
  computed: {
    product() {
      return this.state.item_group.product;
    },

    items() {
      const items = this.state.item_group.items;

      items.forEach(i => (i.product = this.product));

      return items;
    },
  },

  components: { Item },
};
</script>



// WEBPACK FOOTER //
// ItemGroup.vue?04a51670